import { gql } from '@apollo/client';

export const fetchAvailableOfferingsForEntitlement = gql`
  query fetchAvailableOfferingsForEntitlementPPC(
    $id: String
    $transactionAccountId: String
    $isOfferingGroupChangesIncluded: Boolean = false
  ) {
    entitlementDetails(id: $id, filters: { transactionAccountId: $transactionAccountId }) {
      id
      edition
      plan
      transactionAccountId
      offering {
        id
        name
        level
        key
        sku
        productKey
        pricingType
        availableAddOns {
          offeringId
          name
        }
        availableSyntheticPricingPlans {
          type
          status
          discountPercentage
        }
        trial {
          lengthDays
        }
        status
      }
      addOns {
        nodes {
          offeringId
          name
          units
        }
      }
      availableOfferings {
        id
        name
        level
        key
        sku
        productKey
        pricingType
        status
        offeringGroup @include(if: $isOfferingGroupChangesIncluded)
        relationshipRequirements @include(if: $isOfferingGroupChangesIncluded) {
          level
          side
          type
        }
        availableAddOns {
          offeringId
          name
        }
        availableSyntheticPricingPlans {
          type
          status
          discountPercentage
        }
        trial {
          lengthDays
        }
        derivedFromOffering {
          templateId
          templateVersion
          originalOfferingKey
        }
      }
      validOfferings {
        key
        offeringKey
        offeringName
        status
      }
    }
  }
`;
